export default __webpack_public_path__ + "static/media/PlatenKnife.5e3097d8.png";